import { PurchaseOrderInformationFieldNames } from '@contracts/order/fields/PurchaseOrderInformationFields';
import { StringField } from '@src/permitField/PermitFields';

export class PONumberField extends StringField {
  public static fieldName = PurchaseOrderInformationFieldNames.PONumber;
}
